export default __webpack_public_path__ + "static/media/Screenshot (1126).c84c2f86.png";